export interface JobRequestedClassDto {
  requestedTradeClassID: string | null;
  requestedLinkedClassID: string | null;
  requestedClassName: string;
}
